/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const policyPlanRadarTagEntrySeverityMin = 0;
export const policyPlanRadarTagEntrySeverityMax = 5;

export const PolicyPlanRadarTagEntry = zod.object({
	severity: zod
		.number()
		.min(policyPlanRadarTagEntrySeverityMin)
		.max(policyPlanRadarTagEntrySeverityMax)
		.describe('Severity level (0-5)'),
	tag: zod
		.object({
			description: zod.string().nullable().describe('Tag description'),
			formats: zod.array(zod.string()).describe('Content formats this tag applies to'),
			id: zod.string().describe('Tag ID'),
			inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
			key: zod.string().describe('Tag key identifier'),
			name: zod.string().describe('Tag name'),
			organization_id: zod.string().nullable().describe('Organization ID'),
			source: zod.string().describe('Tag source (builtin or custom)'),
			suggested_severity: zod.number().nullable().describe('Suggested severity level (0-5)'),
			updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
		})
		.optional()
		.describe('A tag for categorizing and organizing case items'),
	tag_id: zod.uuid().describe('Tag ID'),
	threshold_override: zod.number().nullish().describe('Per-tag threshold override (0.0-1.0)')
});

export type PolicyPlanRadarTagEntry = zod.input<typeof PolicyPlanRadarTagEntry>;
export type PolicyPlanRadarTagEntryOutput = zod.output<typeof PolicyPlanRadarTagEntry>;
